const rotateNumber = (currentNumber, offset, clockSize) => {
  /**
   * Make sure offset is constrained between the numbers in the clock
   * For example:
   *    Given a starting point of 0
   *    And an offset of -1
   *    And a clock size of 10
   *    Then the result should be 9
   */
  const normalizedOffset = offset % clockSize;
  const nextNumber = (clockSize + (
  // Make sure numbers are always within the first (positive) clock rotation
  currentNumber + normalizedOffset)) % clockSize;
  return nextNumber;
};
export default rotateNumber;